export async function authFetch(url, options = {}) {
  const token = localStorage.getItem("token");
  const baseUrl = process.env.REACT_APP_API_BASE_URL;

  if (!baseUrl) {
    throw new Error("REACT_APP_API_BASE_URL is not defined. Check your .env file.");
  }

  const headers = {
    ...(options.headers || {}),
    Authorization: token ? `Bearer ${token}` : "",
    // "Content-Type": "application/json",
  };

  if (options.body && !(options.body instanceof FormData)) {
    headers["Content-Type"] = "application/json";
  }
  // const response = await fetch(url, { ...options, headers });
  const response = await fetch(`${baseUrl}${url}`, { ...options, headers });

  if (response.status === 401) {
    // Token expired or invalid — logout user
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    window.location.href = "/"; // Redirect to login page
    return; // stop further processing
  }

  return response;
}
